<template>
  <div>
    <b-overlay :show="initializing" rounded="sm">
      <information
        class="mb-3"
        :value="headerData"
        @refresh="GetRestaurantProfile"
      />
      <attributes @refresh="GetRestaurantProfile" class="mb-3" :value="attrs"/>
    </b-overlay>

    <menuTypes
      ref="menuTypes"
      :items="allMenuTypes"
      :edible-type="EdibleType"
      @refreshMenuType="(EdibleType) => GetMenuTypes(EdibleType)"
      :progressing="menuTypeLoading"
      :has-category="hasCategory"
      :profile="profile"
      @getCategories="getCategories"
    />

    <categories
      v-if="allMenuTypes.length"
      ref="categories"
      :items="allCategories"
      :kds-list="KDSs"
      :print-station-list="PrintStations"
      :current-menu-type="currentMenuType"
      :edible-type="EdibleType"
      @getCategories="getCategories"
      @openDuplicateMenu="triggerDuplicateMenu"
      :AllowSecondLang="AllowSecondLang"
      :first-cat="firstCat"
    />
  </div>
</template>

<script>
  import information from './information'
  import attributes from './attributes'
  import menuTypes from './menuTypes'
  import Categories from "./categories/index";

  export default {
    name: "index",
    components: {
      information,
      attributes,
      menuTypes,
      Categories,
    },
    metaInfo() {
      return {
        title: "Menu Editor",
      };
    },
    watch: {
      '$store.state.selectedRestaurantId': {
        handler: function (newVal) {
          if (newVal) {
            this.GetRestaurantProfile()
            this.GetMenuTypes(this.EdibleType)
            this.getAllowanse()
          }
        },
        immediate: true
      },
    },
    data () {
      return {
        attrs: {},
        headerData: {},
        initializing: true,
        allMenuTypes: [],
        EdibleType: 'Food',
        menuTypeLoading: false,
        headerLoading: false,
        AllowSecondLang: false,
        allCategories: [],
        profile: {},
        KDSs: [],
        PrintStations: [],
        firstCat: ''
      }
    },
    computed: {
      currentMenuType () {
        return this.allMenuTypes.find(item => item.selected)
      },
      hasCategory(){
        if(this.allCategories.length > 0)
          return true
        return false
      }
    },
    methods: {
      GetRestaurantProfile() {
        let model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          // UserID: localStorage.getItem("userID"),
        };
        this.initializing = true
        return this.$api.getRestaurant.GetRestaurantProfile(model).then((res) => {
          this.initializing = false
          if (res.success) {
            this.attrs = this.makeRestaurantAttrs(res.results)
            this.headerData = res.results
            this.profile = res.results
            this.initializing = false
          }
        });
      },
      GetMenuTypes (EdibleType) {
        let model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          EdibleType
        };
        this.EdibleType = EdibleType
        this.menuTypeLoading = true
        return this.$api.menuType.list(model).then((res) => {
          this.menuTypeLoading = false
          this.allMenuTypes = res.data.menuTypes
          this.allMenuTypes.forEach((item, index) => {
            if (index === 0) {
              this.$set(item, 'selected', true)
              this.getCategories(item)
            } else {
              this.$set(item, 'selected', false)
            }
          })
        }).catch((err => {
          this.allMenuTypes = []
          this.allCategories = []
        }))
      },
      makeRestaurantAttrs (model) {
        return {
          mealOptions: {
            'Breakfast': model.Breakfast,
            'Lunch': model.Lunch,
            'Dinner': model.Dinner,
            'Brunch': model.Brunch,
            'Snack': model.Snack,
          },
          deliveryOption: {
            'Delivery': model.Delivery,
            'Take Out': model.TakeOut,
            'Catering': model.Catering,
            'Banquet': model.Banquet
          },
          otherOption: {
            'Take Reservations': model.TakeReservations,
            'Happy Hours': model.HappyHours,
            'Outdoor Seating': model.OutdoorSeating,
            'Free Parking': model.FreeParking
          },
          technology: {
            'Free WiFi': model.WiFi,
            'TV': model.HasTV,
          },
          bar: {
            'Alcohol': model.Alcohol,
            'Full Bar': model.FullBar,
            'Beer & Wine Only': model.BeerAndWineOnly,
          }
        }
      },
      getCategories (menuType) {
        const {MenuTypeID} = menuType
        const params = {
          MenuTypeID,
          EdibleType: this.EdibleType,
          RestaurantID: this.$store.state.selectedRestaurantId
        }
        return this.$api.category.list(params).then(res => {
          res.data.categories.forEach(item => {
            item.categoryClass = this.EdibleType === 'Food' ? 'food-category' : 'drink-category'
            this.$set(item, 'open', false)
            item.foods = []
          })
          this.allCategories = res.data.categories
          this.allCategories.forEach((item, index) => {
            if (index === 0) {
              this.firstCat = item.CategoryID
              this.$nextTick(() => {
                this.$refs.categories.getCategoryFoods(item)
              })
            }
          })
          this.KDSs = res.data.KDSs
          this.PrintStations = res.data.PrintStations
        }).catch(() => {

        })
      },
      triggerDuplicateMenu () {
        if (this.$refs.menuTypes) {
          this.$refs.menuTypes.openDuplicateModal()
        }
      },
      getAllowanse () {
        let object = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          // UserID: localStorage.getItem('userID')
        }
        return this.$api.getRestaurant.GetRestaurantAllowance(object).then(res => {
          if (res.success) {
            this.AllowSecondLang = res.results.AllowSecondLang
          }
        })
      },
      // openCategory (category) {
      //     this.allCategories.forEach(item => {
      //         if (item.CategoryID === category.CategoryID) {
      //             if (category.open) {
      //                 item.open = false
      //             } else {
      //                 item.open = true
      //             }
      //         }
      //     })
      // }
    }
  };
</script>

